module.exports = __webpack_public_path__ + "static/media/viure-als-pirineus-2.17796ecb.png";